import apiHeader from '@/helpers/apiHeader'

const scriptService = {
    list(params) {
        return apiHeader.get('general-setting/script-template', { params });
      },
      get(id) {
        return apiHeader.get(`general-setting/script-template/${id}`);
      },
      create(data) {
        return apiHeader.post('general-setting/script-template', data);
      },
      update(code, data) {
        return apiHeader.patch(`general-setting/script-template/${code}`, data);
      },
      delete(code) {
        return apiHeader.delete(`general-setting/script-template/${code}`); 
      },
}

export default scriptService;